export const convertCoordinate = (coordinate: number, isLatitude: boolean): string => {
  let dir: 'W' | 'S' | 'E' | 'N';

  if (coordinate < 0) {
    dir = isLatitude ? 'S' : 'W';
  } else dir = isLatitude ? 'N' : 'E';

  const deg = Math.trunc(coordinate);
  const frac = Math.abs(coordinate - deg);
  const min = Math.trunc(frac * 60);
  const sec = (frac * 3600 - min * 60).toFixed(1);

  return Number.isNaN(deg) ? '' : `${Math.abs(deg)}\u00B0 ${min}' ${sec}"${dir}`;
};
